"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSubmitError = exports.FormValidationSummary = exports.FormErrorSummary = void 0;
var _mui = require("@ori-ui/mui");
var _Localization = require("../Localization");
var _jsxRuntime = require("react/jsx-runtime");
const FormErrorSummary = exports.FormErrorSummary = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: theme.spacing(3)
}));
const StyledSubmitError = exports.StyledSubmitError = (0, _mui.styled)(_mui.FormHelperText)(({
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize,
  textAlign: 'left',
  fontStyle: 'italic',
  marginLeft: theme.spacing(1)
}));
const FormValidationSummary = props => {
  const {
    invalidPropertyErrors
  } = props;
  const isInvalidPropertyErrors = Array.isArray(invalidPropertyErrors) && invalidPropertyErrors.length > 0;
  if (!isInvalidPropertyErrors) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormErrorSummary, {
    children: invalidPropertyErrors?.map(notPropertyError => /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubmitError, {
      error: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: notPropertyError.localization,
        id: notPropertyError.localization
      })
    }, notPropertyError.localization))
  });
};
exports.FormValidationSummary = FormValidationSummary;
//# sourceMappingURL=FormValidationSummary.js.map